import { Spinner } from '@wonderschool/common-base-ui';
import { useTranslation } from 'react-i18next';
import { useAuthUser } from '../../../hooks/useUser';
import { getOpenLedgerUrl } from './open-ledger.utils';

export function OpenLedgerPage() {
  const { t } = useTranslation();
  const { currentUser } = useAuthUser();

  if (!currentUser?.uid) {
    return <Spinner />;
  }

  const url = getOpenLedgerUrl(currentUser.uid);

  return <iframe className="h-[calc(100vh-173px)] w-full" title={t('apps.openLedger.frameTitle')} src={url} />;
}
